export const featuresConfigSelector = state => {
  return state.preferences?.features;
};

export const featuresConfigLoadingSelector = state => {
  return !state.preferences?.features || state.preferences?.loadingFeatures;
};

export const bigClubSettingsSelector = state => {
  return state.preferences?.bigClubSettings;
};
